import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { City } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CityService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public getAllCity(citySearchParam:IGlobalSearchParam):Observable<any> {
      //console.log(citySearchParam);
      return this.apiService.post(`City/SearchCity`,citySearchParam)
    }

    public getCityDetail(cityId:number):Observable<any> {
      return this.apiService.getInd(`City/${cityId}`)
    }
    
    public deleteCityDetail(cityId:number):Observable<any> {
      return this.apiService.delete(`City/${cityId}`)
    }

    public updateCityDetail(cityId:number, city:City):Observable<any> {
      return this.apiService.put(`City/${cityId}`, city)
    } 
    
    public postCityDetail(city:City):Observable<any> {
      return this.apiService.post(`City`, city)
    } 

    public ExportCityResult(citySearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}City/ExportCity`, citySearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }
}
